module.exports = __webpack_public_path__ + "img/win-wecom-allow.b8c08ab9.png";